import React from 'react';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import FolderRoundedIcon from '@mui/icons-material/FolderRounded';
import { ROUTE_ICONS, resolveRouteKey } from '../../Router/routes';

// Indentation added per nesting level, in px. Applied as left padding on a flat
// row instead of as a margin on a nested list so the icon column stays aligned
// across levels.
export const INDENT_STEP = 14;

// A node with children and no destination is a folder: it groups routes without
// being one. Folder names arrive from the server as GUIDs, so they never resolve
// to a route key — which is why a folder never gets an icon.
export const isRouteFolder = (route) =>
  Boolean(route?.subroutes?.length) && !route?.target;

// Icon and label key off the canonical route key, not the server `name`, which
// may be a GUID. A folder falls back to the folder mark rather than to the leaf
// fallback: its name is usually a GUID that maps to nothing, and what it is -
// a group of routes rather than one of them - is worth saying. The
// `CircleOutlinedIcon` fallback then only ever reaches a leaf: a leaf with no
// mapped key is a real (rare) gap worth showing.
export const routeItemProps = (route) => {
  const routeKey = resolveRouteKey(route) ?? route.name;
  const Icon =
    ROUTE_ICONS[routeKey] ??
    (isRouteFolder(route) ? FolderRoundedIcon : CircleOutlinedIcon);

  return {
    routeName: routeKey,
    routePath: route.target ? `/${route.target}` : undefined,
    icon: <Icon />,
    subRoutes: route.subroutes,
  };
};
